import type { ProseData, SectionStatus } from '../../types/canvas';
import { StatusDot } from './StatusDot';
import { ActionBar } from './ActionBar';

interface ProseCardProps {
  title: string;
  data: ProseData;
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function ProseCard({ title, data, status, onApprove, onRefine, onAnother, refineDisabled }: ProseCardProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-[18px] sm:px-[22px] cursor-pointer transition-colors duration-[150ms] hover:border-muted-foreground">
      <div className="flex items-center gap-2 mb-2.5">
        <span className="text-[15px] font-semibold text-foreground">{title}</span>
        <div className="ml-auto"><StatusDot status={status} /></div>
      </div>
      <p className="font-display text-sm italic text-muted-foreground leading-relaxed [font-variation-settings:'opsz'_48,'SOFT'_80]">
        {data.prose}
      </p>
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
